exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.spinner[data-v-7560a870] {\n  border-radius: 100%;\n  display: inline-block;\n  animation: sk-scaleout-data-v-7560a870 1s ease-in-out infinite;\n}\n@keyframes sk-scaleout-data-v-7560a870 {\n0% {\n    transform: scale(0);\n}\n100% {\n    transform: scale(1);\n    opacity: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7560a870","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loading-spinner/node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-loading-spinner/src/components/ScaleOut.vue
// module id = 416
// module chunks = 2